import { type BaseOptionType } from "antd/lib/select"

interface Attachment {
  id: string
  file: string
  original_filename: string
  file_size: number
  formatted_file_size: string
  mime_type: string
  created_by: string | null
  created_by_name: string | null
  created: string
  project: string | null
  model_type_display: string
  related_object_name: string | null
  folder?: string | null
  deleted_at?: string | null
  deleted_by_name?: string | null
  document_type?: string | null
  document_type_label?: string | null
  status?: string | null
  status_label?: string | null
  next_statuses?: string[]
}

interface AttachmentFilterOptions {
  model_types: BaseOptionType[]
  file_types: BaseOptionType[]
  date_ranges: BaseOptionType[]
  milestones: BaseOptionType[]
  financial_items: BaseOptionType[]
  invoices: BaseOptionType[]
  checklist_items: BaseOptionType[]
}

interface AttachmentUploadData {
  file: File
  project_id: string
  object_id: string
  model_type: AttachmentModels
  parent_type?: AttachmentParentModels
  folder?: string
}

enum AttachmentModels {
  CHECKLIST_ITEM = "checklist_item",
  MILESTONE = "milestone",
  INVOICE = "invoice",
  FINANCIAL_ITEM = "financial_item",
  PARTIAL_TRANSACTION_ITEM = "partial_transaction_item",
  PROJECT = "project"
}

enum AttachmentParentModels {
  MILESTONE = "milestone"
}

export type { Attachment, AttachmentFilterOptions, AttachmentUploadData }
export { AttachmentModels, AttachmentParentModels }
